import { FC } from 'react';
import { Box, Typography, Stack, Button, Divider } from '@mui/material';
import { DirigoLogo } from '@shared/components/Logo/DirigoLogo';


interface Props {
  program: Programs.Program;
  onGetStarted: () => void;
}

export const ProgramPreview: FC<Props> = ({ program, onGetStarted }) => {
  return (
    <Stack alignItems="center" spacing={5} sx={{ minHeight: '80vh', py: 4 }}>
      <Box sx={{ opacity: 0.8 }} pb={8}>
        <DirigoLogo/>
      </Box>
      {program.image && (
        <Box
          component="img"
          src={program.image}
          alt={program.name}
          sx={{ maxWidth: 160, maxHeight: 160, objectFit: 'contain' }}
        />
      )}
      <Stack spacing={2} alignItems="center">
        <Typography variant="h3" textAlign="center" fontSize={30}>
          {program.welcomeTitle || program.name}
        </Typography>
        {program.welcomeSubtitle && (
          <Typography variant="overline" textAlign="center" color="text.secondary" maxWidth={480}>
            {program.welcomeSubtitle}
          </Typography>
        )}
      </Stack>

      {program.description && (
        <>
          <Divider flexItem sx={{ borderColor: 'rgba(245, 240, 232, 0.15)' }}/>
          <Typography variant="button" textAlign="center" maxWidth={480} sx={{ whiteSpace: 'pre-line' }} textTransform="none">
            {program.description}
          </Typography>
        </>
      )}

      <Button variant="contained" size="large" onClick={onGetStarted}>
        Get Started
      </Button>
    </Stack>
  );
};
